import { getDate } from "../../utils/convert-date";
import { getDateFromOffset } from "../../utils/convert-date";
export const jobId = "ffc3c55c-628b-fc14-aa56-e13a035e14c3";

export const LOCALSTORAGE_KEYS_WITH_ACCOUNTS = [
  "INSTANCES",
  "IMAGES",
  "VOLUMES",
  "SNAPSHOTS",
  "PATCH_POLICIES",
  "INTEGRATIONS",
  "REPORT_DETAILS",
];

export const cfnPath = "https://console.aws.amazon.com/cloudformation";

export const SECURITY_BOT_INSIGHT_COUNT = 208;
export const COMPLIANCE_BOT_INSIGHT_COUNT = 194;

export const COMPLIANCE_INSIGHTS = [
  {
    AccountNumber: "897930493710",
    ApplicationId: null,
    ApplicationNames: null,
    Apps: [],
    ComplianceType: "NON_COMPLIANT",
    ConfigRuleInvokedTime: "2023-04-18 04:44:36",
    ConfigRuleName: "mc-cloudwatch-log-group-encrypted",
    CreatedAt: "2023-04-18 04:44:50",
    CustomerId: "23229912-3180-4132-bcae-9c54c1a054cf",
    DepartmentId: null,
    DepartmentNames: null,
    Departments: [],
    Description: "Cloudwatch Log Group Encrypted",
    Id: "a0acc2d2-ddcb-46a0-8e30-31d24a17d9f0",
    Metadata:
      '{"NewEvaluationResult": {"annotation": "This log group is not encrypted with the specified AWS KMS key Id.", "complianceType": "NON_COMPLIANT", "resultRecordedTime": "2023-04-18T04:44:36.642Z", "configRuleInvokedTime": "2023-04-18T04:44:35.789Z", "evaluationResultIdentifier": {"orderingTimestamp": "2023-04-18T04:44:21.210Z", "evaluationResultQualifier": {"resourceId": "/aws/ecs/containerinsights/Day2SecurityBotCluster/performance", "resourceType": "AWS::Logs::LogGroup", "configRuleName": "mc-cloudwatch-log-group-encrypted", "evaluationMode": "DETECTIVE"}}}}',
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Policies: [
      {
        PolicyGroup:
          "Operational Best Practices for Management Governance Services",
        PolicyId: "8b63a199-b2ba-5546-becc-fd4ae6caa47b",
      },
      {
        PolicyGroup: "Operational Best Practices for HIPAA Security",
        PolicyId: "197882c9-6930-598f-8c69-442b405f6400",
      },
      {
        PolicyGroup: "Operational Best Practices for NIST 800 171",
        PolicyId: "e58a9a3d-759e-5c5e-99f7-693075b5dbcc",
      },
      {
        PolicyGroup: "Operational Best Practices for PCI DSS",
        PolicyId: "02fac9e9-30a6-5e39-8542-49d70f51ccfa",
      },
      {
        PolicyGroup: "Operational Best Practices for FedRAMP Low",
        PolicyId: "1de49642-3be4-5bdd-b804-20105b254606",
      },
    ],
    RegionCode: "us-east-2",
    RemediationTaskExists: 0,
    ResourceId: "/aws/ecs/containerinsights/Day2SecurityBotCluster/performance",
    ResourceType: "Logs LogGroup",
    ResultRecordedTime: getDateFromOffset(getDate(), -1),
    UpdatedAt: getDateFromOffset(getDate(), 1),
  },
  {
    AccountNumber: "897930493710",
    ApplicationId: null,
    ApplicationNames: null,
    Apps: [],
    ComplianceType: "NON_COMPLIANT",
    ConfigRuleInvokedTime: "2023-04-18 04:44:36",
    ConfigRuleName: "mc-cw-loggroup-retention-period-check",
    CreatedAt: "2023-04-18 04:45:09",
    CustomerId: "23229912-3180-4132-bcae-9c54c1a054cf",
    DepartmentId: null,
    DepartmentNames: null,
    Departments: [],
    Description: "Cw Loggroup Retention Period Check",
    Id: "c171aae5-c433-4a9c-b3c1-2e11f0bb3ac1",
    Metadata:
      '{"NewEvaluationResult": {"annotation": "retentionInDays is less than MinRetentionTime 365 days. Current retentionInDays: 1 days", "complianceType": "NON_COMPLIANT", "resultRecordedTime": "2023-04-18T04:44:36.689Z", "configRuleInvokedTime": "2023-04-18T04:44:35.829Z", "evaluationResultIdentifier": {"orderingTimestamp": "2023-04-18T04:44:21.210Z", "evaluationResultQualifier": {"resourceId": "/aws/ecs/containerinsights/Day2SecurityBotCluster/performance", "resourceType": "AWS::Logs::LogGroup", "configRuleName": "mc-cw-loggroup-retention-period-check", "evaluationMode": "DETECTIVE"}}}}',
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Policies: [
      {
        PolicyGroup:
          "Operational Best Practices for Management Governance Services",
        PolicyId: "6cd49bef-a3b4-5e11-8c40-e1ba218b0706",
      },
      {
        PolicyGroup: "Operational Best Practices for Logging",
        PolicyId: "c94a0389-55de-5627-86ee-c41a7a001388",
      },
      {
        PolicyGroup: "Operational Best Practices for FedRAMP Low",
        PolicyId: "1ebad62a-8605-5c67-8e7c-5ca19fb1d589",
      },
      {
        PolicyGroup: "Operational Best Practices for Data Resiliency",
        PolicyId: "561174e9-8385-5dbc-b015-216e3c7a6b55",
      },
      {
        PolicyGroup: "Operational Best Practices for NIST 800 171",
        PolicyId: "edab462f-3139-5898-b7fc-5d3821c1fc99",
      },
    ],
    RegionCode: "us-east-2",
    RemediationTaskExists: 0,
    ResourceId: "/aws/ecs/containerinsights/Day2SecurityBotCluster/performance",
    ResourceType: "Logs LogGroup",
    ResultRecordedTime: getDateFromOffset(getDate(), -1),
    UpdatedAt: "2023-04-18 04:45:09",
  },
  {
    AccountNumber: "897930493710",
    ApplicationId: null,
    ApplicationNames: null,
    Apps: [],
    ComplianceType: "NON_COMPLIANT",
    ConfigRuleInvokedTime: "2023-04-18 04:44:36",
    ConfigRuleName: "mc-cloudwatch-log-group-encrypted",
    CreatedAt: "2023-04-18 04:45:12",
    CustomerId: "23229912-3180-4132-bcae-9c54c1a054cf",
    DepartmentId: null,
    DepartmentNames: null,
    Departments: [],
    Description: "Cloudwatch Log Group Encrypted",
    Id: "a3ab6933-4552-4acb-937a-c9b028cbfc10",
    Metadata:
      '{"NewEvaluationResult": {"annotation": "This log group is not encrypted with the specified AWS KMS key Id.", "complianceType": "NON_COMPLIANT", "resultRecordedTime": "2023-04-18T04:44:36.648Z", "configRuleInvokedTime": "2023-04-18T04:44:35.789Z", "evaluationResultIdentifier": {"orderingTimestamp": "2023-04-18T04:44:21.210Z", "evaluationResultQualifier": {"resourceId": "/aws/lambda/MontyCloud-CleanUpLambdaFunction", "resourceType": "AWS::Logs::LogGroup", "configRuleName": "mc-cloudwatch-log-group-encrypted", "evaluationMode": "DETECTIVE"}}}}',
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Policies: [
      {
        PolicyGroup:
          "Operational Best Practices for Management Governance Services",
        PolicyId: "8b63a199-b2ba-5546-becc-fd4ae6caa47b",
      },
      {
        PolicyGroup: "Operational Best Practices for HIPAA Security",
        PolicyId: "197882c9-6930-598f-8c69-442b405f6400",
      },
      {
        PolicyGroup: "Operational Best Practices for NIST 800 171",
        PolicyId: "e58a9a3d-759e-5c5e-99f7-693075b5dbcc",
      },
      {
        PolicyGroup: "Operational Best Practices for PCI DSS",
        PolicyId: "02fac9e9-30a6-5e39-8542-49d70f51ccfa",
      },
      {
        PolicyGroup: "Operational Best Practices for FedRAMP Low",
        PolicyId: "1de49642-3be4-5bdd-b804-20105b254606",
      },
    ],
    RegionCode: "us-east-2",
    RemediationTaskExists: 0,
    ResourceId: "/aws/lambda/MontyCloud-CleanUpLambdaFunction",
    ResourceType: "Logs LogGroup",
    ResultRecordedTime: getDateFromOffset(getDate(), -1),
    UpdatedAt: "2023-04-18 04:45:12",
  },
  {
    AccountNumber: "897930493710",
    ApplicationId: null,
    ApplicationNames: null,
    Apps: [],
    ComplianceType: "COMPLIANT",
    ConfigRuleInvokedTime: "2023-04-18 04:44:36",
    ConfigRuleName: "mc-cw-loggroup-retention-period-check",
    CreatedAt: "2023-04-18 04:45:16",
    CustomerId: "23229912-3180-4132-bcae-9c54c1a054cf",
    DepartmentId: null,
    DepartmentNames: null,
    Departments: [],
    Description: "Cw Loggroup Retention Period Check",
    Id: "798e994c-0c20-466e-83ea-928ec9b873bb",
    Metadata:
      '{"NewEvaluationResult": {"complianceType": "COMPLIANT", "resultRecordedTime": "2023-04-18T04:44:36.700Z", "configRuleInvokedTime": "2023-04-18T04:44:35.829Z", "evaluationResultIdentifier": {"orderingTimestamp": "2023-04-18T04:44:21.210Z", "evaluationResultQualifier": {"resourceId": "/aws/lambda/MontyCloud-CleanUpLambdaFunction", "resourceType": "AWS::Logs::LogGroup", "configRuleName": "mc-cw-loggroup-retention-period-check", "evaluationMode": "DETECTIVE"}}}}',
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Policies: [
      {
        PolicyGroup:
          "Operational Best Practices for Management Governance Services",
        PolicyId: "6cd49bef-a3b4-5e11-8c40-e1ba218b0706",
      },
      {
        PolicyGroup: "Operational Best Practices for Logging",
        PolicyId: "c94a0389-55de-5627-86ee-c41a7a001388",
      },
      {
        PolicyGroup: "Operational Best Practices for FedRAMP Low",
        PolicyId: "1ebad62a-8605-5c67-8e7c-5ca19fb1d589",
      },
      {
        PolicyGroup: "Operational Best Practices for Data Resiliency",
        PolicyId: "561174e9-8385-5dbc-b015-216e3c7a6b55",
      },
      {
        PolicyGroup: "Operational Best Practices for NIST 800 171",
        PolicyId: "edab462f-3139-5898-b7fc-5d3821c1fc99",
      },
    ],
    RegionCode: "us-east-2",
    RemediationTaskExists: 0,
    ResourceId: "/aws/lambda/MontyCloud-CleanUpLambdaFunction",
    ResourceType: "Logs LogGroup",
    ResultRecordedTime: getDateFromOffset(getDate(), -1),
    UpdatedAt: "2023-04-18 04:45:16",
  },
  {
    AccountNumber: "897930493710",
    ApplicationId: null,
    ApplicationNames: null,
    Apps: [],
    ComplianceType: "NON_COMPLIANT",
    ConfigRuleInvokedTime: "2023-04-18 04:44:36",
    ConfigRuleName: "mc-cloudwatch-log-group-encrypted",
    CreatedAt: "2023-04-18 04:44:44",
    CustomerId: "23229912-3180-4132-bcae-9c54c1a054cf",
    DepartmentId: null,
    DepartmentNames: null,
    Departments: [],
    Description: "Cloudwatch Log Group Encrypted",
    Id: "e9988fe2-3457-439d-8740-fe0dcc0950f7",
    Metadata:
      '{"NewEvaluationResult": {"annotation": "This log group is not encrypted with the specified AWS KMS key Id.", "complianceType": "NON_COMPLIANT", "resultRecordedTime": "2023-04-18T04:44:36.654Z", "configRuleInvokedTime": "2023-04-18T04:44:35.789Z", "evaluationResultIdentifier": {"orderingTimestamp": "2023-04-18T04:44:21.210Z", "evaluationResultQualifier": {"resourceId": "/aws/lambda/MontyCloud-Desired-Accoun-IamPasswordPolicyCustomR-3HBSZ3JE7KCU", "resourceType": "AWS::Logs::LogGroup", "configRuleName": "mc-cloudwatch-log-group-encrypted", "evaluationMode": "DETECTIVE"}}}}',
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Policies: [
      {
        PolicyGroup:
          "Operational Best Practices for Management Governance Services",
        PolicyId: "8b63a199-b2ba-5546-becc-fd4ae6caa47b",
      },
      {
        PolicyGroup: "Operational Best Practices for HIPAA Security",
        PolicyId: "197882c9-6930-598f-8c69-442b405f6400",
      },
      {
        PolicyGroup: "Operational Best Practices for NIST 800 171",
        PolicyId: "e58a9a3d-759e-5c5e-99f7-693075b5dbcc",
      },
      {
        PolicyGroup: "Operational Best Practices for PCI DSS",
        PolicyId: "02fac9e9-30a6-5e39-8542-49d70f51ccfa",
      },
      {
        PolicyGroup: "Operational Best Practices for FedRAMP Low",
        PolicyId: "1de49642-3be4-5bdd-b804-20105b254606",
      },
    ],
    RegionCode: "us-east-2",
    RemediationTaskExists: 0,
    ResourceId:
      "/aws/lambda/MontyCloud-Desired-Accoun-IamPasswordPolicyCustomR-3HBSZ3JE7KCU",
    ResourceType: "Logs LogGroup",
    ResultRecordedTime: getDateFromOffset(getDate(), -1),
    UpdatedAt: "2023-04-18 04:44:44",
  },
  {
    AccountNumber: "897930493710",
    ApplicationId: null,
    ApplicationNames: null,
    Apps: [],
    ComplianceType: "COMPLIANT",
    ConfigRuleInvokedTime: "2023-04-18 04:44:36",
    ConfigRuleName: "mc-cw-loggroup-retention-period-check",
    CreatedAt: "2023-04-18 04:45:13",
    CustomerId: "23229912-3180-4132-bcae-9c54c1a054cf",
    DepartmentId: null,
    DepartmentNames: null,
    Departments: [],
    Description: "Cw Loggroup Retention Period Check",
    Id: "19109d1d-fc03-422c-ba10-085a91e785f9",
    Metadata:
      '{"NewEvaluationResult": {"complianceType": "COMPLIANT", "resultRecordedTime": "2023-04-18T04:44:36.709Z", "configRuleInvokedTime": "2023-04-18T04:44:35.829Z", "evaluationResultIdentifier": {"orderingTimestamp": "2023-04-18T04:44:21.210Z", "evaluationResultQualifier": {"resourceId": "/aws/lambda/MontyCloud-Desired-Accoun-IamPasswordPolicyCustomR-3HBSZ3JE7KCU", "resourceType": "AWS::Logs::LogGroup", "configRuleName": "mc-cw-loggroup-retention-period-check", "evaluationMode": "DETECTIVE"}}}}',
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Policies: [
      {
        PolicyGroup:
          "Operational Best Practices for Management Governance Services",
        PolicyId: "6cd49bef-a3b4-5e11-8c40-e1ba218b0706",
      },
      {
        PolicyGroup: "Operational Best Practices for Logging",
        PolicyId: "c94a0389-55de-5627-86ee-c41a7a001388",
      },
      {
        PolicyGroup: "Operational Best Practices for FedRAMP Low",
        PolicyId: "1ebad62a-8605-5c67-8e7c-5ca19fb1d589",
      },
      {
        PolicyGroup: "Operational Best Practices for Data Resiliency",
        PolicyId: "561174e9-8385-5dbc-b015-216e3c7a6b55",
      },
      {
        PolicyGroup: "Operational Best Practices for NIST 800 171",
        PolicyId: "edab462f-3139-5898-b7fc-5d3821c1fc99",
      },
    ],
    RegionCode: "us-east-2",
    RemediationTaskExists: 0,
    ResourceId:
      "/aws/lambda/MontyCloud-Desired-Accoun-IamPasswordPolicyCustomR-3HBSZ3JE7KCU",
    ResourceType: "Logs LogGroup",
    ResultRecordedTime: getDateFromOffset(getDate(), -1),
    UpdatedAt: "2023-04-18 04:45:13",
  },
  {
    AccountNumber: "897930493710",
    ApplicationId: null,
    ApplicationNames: null,
    Apps: [],
    ComplianceType: "NON_COMPLIANT",
    ConfigRuleInvokedTime: "2023-04-18 04:44:36",
    ConfigRuleName: "mc-cloudwatch-log-group-encrypted",
    CreatedAt: "2023-04-18 04:45:07",
    CustomerId: "23229912-3180-4132-bcae-9c54c1a054cf",
    DepartmentId: null,
    DepartmentNames: null,
    Departments: [],
    Description: "Cloudwatch Log Group Encrypted",
    Id: "40ab404b-561f-4778-9367-d59754049e4e",
    Metadata:
      '{"NewEvaluationResult": {"annotation": "This log group is not encrypted with the specified AWS KMS key Id.", "complianceType": "NON_COMPLIANT", "resultRecordedTime": "2023-04-18T04:44:36.660Z", "configRuleInvokedTime": "2023-04-18T04:44:35.789Z", "evaluationResultIdentifier": {"orderingTimestamp": "2023-04-18T04:44:21.210Z", "evaluationResultQualifier": {"resourceId": "/aws/lambda/MontyCloud-Desired-Accoun-IamPasswordPolicyCustomR-ZSZ13G4KWGRC", "resourceType": "AWS::Logs::LogGroup", "configRuleName": "mc-cloudwatch-log-group-encrypted", "evaluationMode": "DETECTIVE"}}}}',
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Policies: [
      {
        PolicyGroup:
          "Operational Best Practices for Management Governance Services",
        PolicyId: "8b63a199-b2ba-5546-becc-fd4ae6caa47b",
      },
      {
        PolicyGroup: "Operational Best Practices for HIPAA Security",
        PolicyId: "197882c9-6930-598f-8c69-442b405f6400",
      },
      {
        PolicyGroup: "Operational Best Practices for NIST 800 171",
        PolicyId: "e58a9a3d-759e-5c5e-99f7-693075b5dbcc",
      },
      {
        PolicyGroup: "Operational Best Practices for PCI DSS",
        PolicyId: "02fac9e9-30a6-5e39-8542-49d70f51ccfa",
      },
      {
        PolicyGroup: "Operational Best Practices for FedRAMP Low",
        PolicyId: "1de49642-3be4-5bdd-b804-20105b254606",
      },
    ],
    RegionCode: "us-east-2",
    RemediationTaskExists: 0,
    ResourceId:
      "/aws/lambda/MontyCloud-Desired-Accoun-IamPasswordPolicyCustomR-ZSZ13G4KWGRC",
    ResourceType: "Logs LogGroup",
    ResultRecordedTime: getDateFromOffset(getDate(), -1),
    UpdatedAt: "2023-04-18 04:45:07",
  },
  {
    AccountNumber: "897930493710",
    ApplicationId: null,
    ApplicationNames: null,
    Apps: [],
    ComplianceType: "COMPLIANT",
    ConfigRuleInvokedTime: "2023-04-18 04:44:36",
    ConfigRuleName: "mc-cw-loggroup-retention-period-check",
    CreatedAt: "2023-04-18 04:44:51",
    CustomerId: "23229912-3180-4132-bcae-9c54c1a054cf",
    DepartmentId: null,
    DepartmentNames: null,
    Departments: [],
    Description: "Cw Loggroup Retention Period Check",
    Id: "fa13a426-acce-40f4-b37c-2e6136ae8e65",
    Metadata:
      '{"NewEvaluationResult": {"complianceType": "COMPLIANT", "resultRecordedTime": "2023-04-18T04:44:36.718Z", "configRuleInvokedTime": "2023-04-18T04:44:35.829Z", "evaluationResultIdentifier": {"orderingTimestamp": "2023-04-18T04:44:21.210Z", "evaluationResultQualifier": {"resourceId": "/aws/lambda/MontyCloud-Desired-Accoun-IamPasswordPolicyCustomR-ZSZ13G4KWGRC", "resourceType": "AWS::Logs::LogGroup", "configRuleName": "mc-cw-loggroup-retention-period-check", "evaluationMode": "DETECTIVE"}}}}',
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Policies: [
      {
        PolicyGroup:
          "Operational Best Practices for Management Governance Services",
        PolicyId: "6cd49bef-a3b4-5e11-8c40-e1ba218b0706",
      },
      {
        PolicyGroup: "Operational Best Practices for Logging",
        PolicyId: "c94a0389-55de-5627-86ee-c41a7a001388",
      },
      {
        PolicyGroup: "Operational Best Practices for FedRAMP Low",
        PolicyId: "1ebad62a-8605-5c67-8e7c-5ca19fb1d589",
      },
      {
        PolicyGroup: "Operational Best Practices for Data Resiliency",
        PolicyId: "561174e9-8385-5dbc-b015-216e3c7a6b55",
      },
      {
        PolicyGroup: "Operational Best Practices for NIST 800 171",
        PolicyId: "edab462f-3139-5898-b7fc-5d3821c1fc99",
      },
    ],
    RegionCode: "us-east-2",
    RemediationTaskExists: 0,
    ResourceId:
      "/aws/lambda/MontyCloud-Desired-Accoun-IamPasswordPolicyCustomR-ZSZ13G4KWGRC",
    ResourceType: "Logs LogGroup",
    ResultRecordedTime: getDateFromOffset(getDate(), -1),
    UpdatedAt: "2023-04-18 04:44:51",
  },
  {
    AccountNumber: "897930493710",
    ApplicationId: null,
    ApplicationNames: null,
    Apps: [],
    ComplianceType: "NON_COMPLIANT",
    ConfigRuleInvokedTime: "2023-04-18 04:44:36",
    ConfigRuleName: "mc-cloudwatch-log-group-encrypted",
    CreatedAt: "2023-04-18 04:45:11",
    CustomerId: "23229912-3180-4132-bcae-9c54c1a054cf",
    DepartmentId: null,
    DepartmentNames: null,
    Departments: [],
    Description: "Cloudwatch Log Group Encrypted",
    Id: "2a8d45b0-1221-4a06-bfb4-2a3dc3b2ae50",
    Metadata:
      '{"NewEvaluationResult": {"annotation": "This log group is not encrypted with the specified AWS KMS key Id.", "complianceType": "NON_COMPLIANT", "resultRecordedTime": "2023-04-18T04:44:36.666Z", "configRuleInvokedTime": "2023-04-18T04:44:35.789Z", "evaluationResultIdentifier": {"orderingTimestamp": "2023-04-18T04:44:21.210Z", "evaluationResultQualifier": {"resourceId": "/aws/lambda/SecurityBot-ChatOps", "resourceType": "AWS::Logs::LogGroup", "configRuleName": "mc-cloudwatch-log-group-encrypted", "evaluationMode": "DETECTIVE"}}}}',
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Policies: [
      {
        PolicyGroup:
          "Operational Best Practices for Management Governance Services",
        PolicyId: "8b63a199-b2ba-5546-becc-fd4ae6caa47b",
      },
      {
        PolicyGroup: "Operational Best Practices for HIPAA Security",
        PolicyId: "197882c9-6930-598f-8c69-442b405f6400",
      },
      {
        PolicyGroup: "Operational Best Practices for NIST 800 171",
        PolicyId: "e58a9a3d-759e-5c5e-99f7-693075b5dbcc",
      },
      {
        PolicyGroup: "Operational Best Practices for PCI DSS",
        PolicyId: "02fac9e9-30a6-5e39-8542-49d70f51ccfa",
      },
      {
        PolicyGroup: "Operational Best Practices for FedRAMP Low",
        PolicyId: "1de49642-3be4-5bdd-b804-20105b254606",
      },
    ],
    RegionCode: "us-east-2",
    RemediationTaskExists: 0,
    ResourceId: "/aws/lambda/SecurityBot-ChatOps",
    ResourceType: "Logs LogGroup",
    ResultRecordedTime: getDateFromOffset(getDate(), -1),
    UpdatedAt: "2023-04-18 04:45:11",
  },
  {
    AccountNumber: "897930493710",
    ApplicationId: null,
    ApplicationNames: null,
    Apps: [],
    ComplianceType: "COMPLIANT",
    ConfigRuleInvokedTime: "2023-04-18 04:44:36",
    ConfigRuleName: "mc-cw-loggroup-retention-period-check",
    CreatedAt: "2023-04-18 04:45:15",
    CustomerId: "23229912-3180-4132-bcae-9c54c1a054cf",
    DepartmentId: null,
    DepartmentNames: null,
    Departments: [],
    Description: "Cw Loggroup Retention Period Check",
    Id: "3e01ed03-224f-4971-a03b-885a558704ae",
    Metadata:
      '{"NewEvaluationResult": {"complianceType": "COMPLIANT", "resultRecordedTime": "2023-04-18T04:44:36.728Z", "configRuleInvokedTime": "2023-04-18T04:44:35.829Z", "evaluationResultIdentifier": {"orderingTimestamp": "2023-04-18T04:44:21.210Z", "evaluationResultQualifier": {"resourceId": "/aws/lambda/SecurityBot-ChatOps", "resourceType": "AWS::Logs::LogGroup", "configRuleName": "mc-cw-loggroup-retention-period-check", "evaluationMode": "DETECTIVE"}}}}',
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Policies: [
      {
        PolicyGroup:
          "Operational Best Practices for Management Governance Services",
        PolicyId: "6cd49bef-a3b4-5e11-8c40-e1ba218b0706",
      },
      {
        PolicyGroup: "Operational Best Practices for Logging",
        PolicyId: "c94a0389-55de-5627-86ee-c41a7a001388",
      },
      {
        PolicyGroup: "Operational Best Practices for FedRAMP Low",
        PolicyId: "1ebad62a-8605-5c67-8e7c-5ca19fb1d589",
      },
      {
        PolicyGroup: "Operational Best Practices for Data Resiliency",
        PolicyId: "561174e9-8385-5dbc-b015-216e3c7a6b55",
      },
      {
        PolicyGroup: "Operational Best Practices for NIST 800 171",
        PolicyId: "edab462f-3139-5898-b7fc-5d3821c1fc99",
      },
    ],
    RegionCode: "us-east-2",
    RemediationTaskExists: 0,
    ResourceId: "/aws/lambda/SecurityBot-ChatOps",
    ResourceType: "Logs LogGroup",
    ResultRecordedTime: getDateFromOffset(getDate(), -1),
    UpdatedAt: "2023-04-18 04:45:15",
  },
];
